import * as tslib_1 from "tslib";
import { Model } from '@app/models/model';
import { CONSTANTS } from '@app/shared/constants';
import { COLOR_CONSTANTS } from '@app/shared/scss-variables.generated';
var COLORS = {
    RED: COLOR_CONSTANTS['$red-clay'],
    ORANGE: COLOR_CONSTANTS['$sunset'],
    GREEN: COLOR_CONSTANTS['$cut-grass'],
};
var Budget = /** @class */ (function (_super) {
    tslib_1.__extends(Budget, _super);
    function Budget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Budget.prototype, "hexColor", {
        get: function () {
            var perc = (this.actual * 100) / this.value;
            return perc >= 91 ? COLORS.RED : perc <= 50 ? COLORS.GREEN : COLORS.ORANGE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Budget.prototype, "percentages", {
        get: function () {
            var _this = this;
            return (this.thresholds || []).map(function (thresh) { return Math.round((thresh / _this.value) * 100); });
        },
        set: function (values) {
            var _this = this;
            this.thresholds = (values || []).map(function (val) { return Math.round((val * _this.value) / 100); });
        },
        enumerable: true,
        configurable: true
    });
    Budget.types = CONSTANTS.budgetTypes;
    return Budget;
}(Model));
export { Budget };
